import * as XLSX from "xlsx";

export const exportToExcel = (
  productName,
  stockKeepingUnitPrefix,
  variantAttributes,
  combinations
) => {
  const workbook = XLSX.utils.book_new();

  // Sheet 1: Product Info
  const productInfoData = [
    {
      name: productName,
      SKU: stockKeepingUnitPrefix,
    },
  ];
  const productInfoSheet = XLSX.utils.json_to_sheet(productInfoData);
  XLSX.utils.book_append_sheet(workbook, productInfoSheet, "Product Info");

  // Sheet 2: Information about the variant attributes
  const variantAttributesData = [];
  variantAttributes.forEach((attr) => {
    const attrData = {
      id: attr.attribute.id,
      name: attr.attribute.name,
      values: attr.values.join(", "),
    };
    variantAttributesData.push(attrData);
  });
  const variantAttributesSheet = XLSX.utils.json_to_sheet(
    variantAttributesData
  );
  XLSX.utils.book_append_sheet(
    workbook,
    variantAttributesSheet,
    "Variant Attributes"
  );

  // Sheet 3: Combinations of product variants
  const productVariantsData = combinations.map((combination) => ({
    ...combination,
    name: combination.name || "", // Ensure 'name' is included
  }));
  const productVariantsSheet = XLSX.utils.json_to_sheet(productVariantsData);
  XLSX.utils.book_append_sheet(
    workbook,
    productVariantsSheet,
    "Product Variants"
  );

  XLSX.writeFile(workbook, "product_variants.xlsx");
};
